// extracted by mini-css-extract-plugin
module.exports = {"pagination":"TablePagination_pagination__2fiwA"};